import carousel from './components/carousel';

class CarouselRunner {
    constructor() {
        carousel.initCarouselComponent();
    }
}

const carouselRunner = new CarouselRunner();



// WEBPACK FOOTER //
// ./assets/scripts/carousel.js